import React, { useEffect, useState } from "react";
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";

import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Intro from "./components/Intro";
import Navbar from "./components/Navbar";
import Project from "./components/Project";

const App = () => {
  useEffect(() => {
    AOS.init({
      disable: "mobile",
    });
    AOS.refresh();
  }, []);

  const [color, setColor] = useState(false);
  const changeColor = () => {
    if (window.scrollY >= 90) {
      setColor(true);
    } else {
      setColor(false);
    }
  };

  window.addEventListener("scroll", changeColor);

  return (
    <div className="App">
      <div className="backgrounds overlay">
        <div className="background" data-aos="fade-in" data-aos-duration="1500" data-aos-anchor=".section--hero"></div>
      </div>

      <header className={"fixed-top " + (color ? "header header-bg" : " header")}>
        <Navbar />
      </header>

      <div className="contents">
        <Home />
        <Intro />
        <Project />
        <Contact />
      </div>

      <footer className="container-fluid p-0">
        <Footer />
      </footer>

      <div className="fixed-md-bottom">
        <a href="#home" className={"d-none" + (color ? " d-md-inline-block" : "")}>
          <i className="bi bi-chevron-up"></i>
        </a>
      </div>
    </div>
  );
};

export default App;
